<!-- Please don’t change these IDs because those are for automated testing:- storeNameInput, storeDescriptionInput, storeRedeemInput, storeAdsOneInput, storeAdsTwoInput, storeCityInput, storeStateInput, storeZcodeInput, storeCountryInput, storeTypeNameSelect, storeBillingAdsInput, storeImgDeleteLink, storeImgUploadInput, storeCancelOneBtn, storeCancelTwoBtn, storeSkipBtn, storeCancelLink, storeSunmitBtn  -->

<form [ngClass]="{'form__row store-form-admin':!isStoreAddForm, '':isStoreAddForm }" [formGroup]="storeForm" (ngSubmit)="onStoreDataSubmit()">
  <div class="form">
    <!-- <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="yesno__type__radio business__type__radio">
          <div class="yesno__radio__box">
            <input class="css-checkbox yesa" name="locationType" type="checkbox" value="store" id="control_av0"
              [checked]="isLocationTypeSelected('store')" (change)="onLocationTypeChange($event, 'store')" />
            <label class="css-label radGroup2" for="control_av0">Store Location</label>
          </div>
          <div class="yesno__radio__box">
            <input class="css-checkbox no" name="locationType" type="checkbox" value="corporate" id="control_av1"
              [checked]="isLocationTypeSelected('corporate')" (change)="onLocationTypeChange($event, 'corporate')" />
            <label class="css-label radGroup2" for="control_av1">Corporate Location</label>
          </div>
        </div>
        @if (storeForm.controls.locationType.invalid && (isSubmitted)) {
          <div class="custom_error">
            {{getCustomErrorMessage(storeForm.controls.locationType, 'Location Type')}}
          </div>
        }
      </div>
    </div> -->
    <div [ngClass]="{'input__row':!isStoreAddForm, 'row':isStoreAddForm }">
      <div [ngClass]="{'col-sm-7':!isStoreAddForm, 'col-lg-12 col-md-12 col-sm-12':isStoreAddForm }">
        <div [ngClass]="{'input-field':!isStoreAddForm, 'login__input':isStoreAddForm }">
          @if (!isStoreAddForm || isStoreAddPopup) {
            <label>{{translations.STORE.STORE_NAME | translate}}</label>
          }
          <input type="text" id="storeNameInput" placeholder="Business Name" formControlName="storeName" />
          @if (storeForm.controls.storeName.invalid &&
            (isSubmitted)) {
            <div
              class="custom_error">
              <!-- {{getCustomErrorMessage(storeForm.controls.storeName, getTranslation(translations.GLOBAL.KEYS.STORE_NAME), { cannotStartWithWhiteSpace: true, minLength:3, maxLength:25 })}} -->
              {{getCustomErrorMessage(storeForm.controls.storeName, getTranslation(translations.GLOBAL.KEYS.BUSINESS_NAME) )}}
            </div>
          }
        </div>
      </div>
    </div>

    <div [ngClass]="{'input__row':!isStoreAddForm, 'row':isStoreAddForm }">
      <div [ngClass]="{'col-sm-7':!isStoreAddForm, 'col-lg-12 col-md-12 col-sm-12':isStoreAddForm }">
        <div [ngClass]="{'input-field':!isStoreAddForm, 'login__input':isStoreAddForm }">
          @if (!isStoreAddForm || isStoreAddPopup) {
            <label>{{translations.GLOBAL.KEYS.STORE_DESCRIPTION | translate}}</label>
          }
          <textarea id="storeDescriptionInput" class="text__area__height__100" formControlName="stroeDesc"
          placeholder="Business Description"></textarea>
          @if (storeForm.controls.stroeDesc.invalid &&
            (isSubmitted)) {
            <div
              class="custom_error">
              <!-- {{getCustomErrorMessage(storeForm.controls.stroeDesc, getTranslation(translations.GLOBAL.KEYS.STORE_DESCRIPTION), { cannotStartWithWhiteSpace: true, minLength:3, maxLength:250 })}} -->
              {{getCustomErrorMessage(storeForm.controls.stroeDesc, getTranslation(translations.GLOBAL.KEYS.STORE_DESCRIPTION) )}}
            </div>
          }
        </div>
      </div>
    </div>

    <div [ngClass]="{'input__row':!isStoreAddForm, 'row':isStoreAddForm }">
      <div [ngClass]="{'col-sm-7':!isStoreAddForm, 'col-lg-12 col-md-12 col-sm-12':isStoreAddForm }">
        <div [ngClass]="{'input-field':!isStoreAddForm, 'login__input':isStoreAddForm }">
          @if (!isStoreAddForm || isStoreAddPopup) {
            <label>{{translations.GLOBAL.KEYS.BUSINESS_PHONE_NUMBER | translate}}</label>
          }
          <input type="text" id="storePhoneInput" placeholder="Business Phone Number" formControlName="businessPhone"
            (input)="formatPhoneNumber($event)" />
          @if (storeForm.controls.businessPhone.invalid &&
            (isSubmitted)) {
            <div
              class="custom_error">
              {{getCustomErrorMessage(storeForm.controls.businessPhone, getTranslation(translations.GLOBAL.KEYS.BUSINESS_PHONE_NUMBER) )}}
            </div>
          }
        </div>
      </div>
    </div>

    <div [ngClass]="{'input__row':!isStoreAddForm, 'row':isStoreAddForm }">
      <div [ngClass]="{'col-sm-7':!isStoreAddForm, 'col-lg-12 col-md-12 col-sm-12':isStoreAddForm }">
        <strong class="physical-address-text">{{ translations.GLOBAL.KEYS.PHYSICAL_ADDRESS_TEXT | translate }}</strong>
      </div>
    </div>

    <div [ngClass]="{'input__row':!isStoreAddForm, 'row':isStoreAddForm }">
      <div [ngClass]="{'col-sm-7':!isStoreAddForm, 'col-lg-12 col-md-12 col-sm-12':isStoreAddForm }">
        <div class="form-check billing-address-check">
          <div class="remember-me">
            <input class="css-checkbox" id="sameAsMailingCheckbox" formControlName="isSameAsMailingAddress"
              (change)="onSameAsMailingAddressChange($event)" name="sameAsMailingCheckbox" type="checkbox">
            <label class="css-label" for="sameAsMailingCheckbox">{{ translations.GLOBAL.KEYS.SAME_AS_MAILING_ADDRESS_LABEL | translate }}</label>
          </div>
        </div>
      </div>
    </div>

    <div [ngClass]="{'input__row':!isStoreAddForm, 'row':isStoreAddForm }">
      <div formGroupName="storeAddress" [ngClass]="{'col-sm-7':!isStoreAddForm, 'col-lg-12 col-md-12 col-sm-12':isStoreAddForm }">
        <div [ngClass]="{'input-field':!isStoreAddForm, 'login__input':isStoreAddForm }">
          @if (!isStoreAddForm || isStoreAddPopup) {
            <label>{{translations.GLOBAL.KEYS.ADDRESS_1 | translate }}</label>
          }
          <input type="text" id="storeAdsOneInput" placeholder="Address 1" autocorrect="off"
            autocapitalize="off" spellcheck="off" #searchStoreAdd
            (input)="searchGoogleAutocompleteAddress($event); handleManualAddressInput($event)"
            (blur)="handleAddressBlur($event)"
            formControlName="formattedAddress" (click)="clearAddressFieldValidation()"/>
          @if (isSubmitted && formattedAddress.invalid) {
            <div class="custom_error">
              @if (formattedAddress.errors && formattedAddress.errors.required) {
                <div>
                  {{
                  translations.GLOBAL.VALIDATION_MESSAGES.REQUIRED |
                  translate : { 'name': translations.GLOBAL.KEYS.ADDRESS | translate }
                  }}
                </div>
              }
              @if (formattedAddress.errors.pleaseSelectValidAddressFromList && (!formattedAddress.errors || !formattedAddress.errors.required)) {
                <div>
                  {{
                  translations.GLOBAL.VALIDATION_MESSAGES.CHOOSE_ADDRESS_FROM_DROPDOWN |
                  translate : { 'name': translations.GLOBAL.KEYS.ADDRESS | translate }
                  }}
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>

    <div [ngClass]="{'input__row':!isStoreAddForm, 'row':isStoreAddForm }">
      <div [ngClass]="{'col-sm-7':!isStoreAddForm, 'col-lg-12 col-md-12 col-sm-12':isStoreAddForm }" formGroupName="storeAddress">
        <div [ngClass]="{'input-field':!isStoreAddForm, 'login__input':isStoreAddForm }">
          @if (!isStoreAddForm || isStoreAddPopup) {
            <label>{{translations.GLOBAL.KEYS.ADDRESS_2 | translate}}</label>
          }
          <input type="text" id="storeAdsTwoInput" placeholder="Address 2"
            formControlName="customAddress" />
          <div class="custom_error">
            {{getCustomErrorMessage(storeAddressForm.customAddress, getTranslation(translations.GLOBAL.KEYS.CUSTOM_ADDRESS) )}}
          </div>
        </div>
      </div>
    </div>
    <div formGroupName="storeAddress"  [ngClass]="{'input__row':!isStoreAddForm, 'row':isStoreAddForm }">

      <div  [ngClass]="{'col-sm-7':!isStoreAddForm, 'col-lg-6 col-md-12 col-sm-6':isStoreAddForm }">
        <div [ngClass]="{'input-field':!isStoreAddForm, 'login__input':isStoreAddForm }">
          @if (!isStoreAddForm || isStoreAddPopup) {
            <label>{{translations.GLOBAL.KEYS.CITY | translate}}</label>
          }
          <input type="text" id="storeCityInput" [placeholder]="getTranslation(translations.GLOBAL.KEYS.CITY)" formControlName="city"/>
          @if (storeAddressForm.city.invalid &&
            (isSubmitted)) {
            <div
              class="custom_error">
              @if (storeAddressForm.city.errors.required) {
                <div>
                  {{getCustomErrorMessage(storeAddressForm.city, getTranslation(translations.GLOBAL.KEYS.CITY))}}
                </div>
              }
            </div>
          }
        </div>
      </div>
      <div  [ngClass]="{'col-sm-7':!isStoreAddForm, 'col-lg-6 col-md-12 col-sm-6':isStoreAddForm }">
        <div [ngClass]="{'input-field':!isStoreAddForm, 'login__input':isStoreAddForm }">
          @if (!isStoreAddForm || isStoreAddPopup) {
            <label>{{translations.GLOBAL.KEYS.STATE | translate }}</label>
          }
          <input type="text" id="storeStateInput" [placeholder]="getTranslation(translations.GLOBAL.KEYS.STATE)" formControlName="state" />
          @if (storeAddressForm.state.invalid &&
            (isSubmitted)) {
            <div
              class="custom_error">
              @if (storeAddressForm.state.errors.required) {
                <div>
                  {{getCustomErrorMessage(storeAddressForm.state, getTranslation(translations.GLOBAL.KEYS.STATE))}}
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>

    <div [ngClass]="{'input__row':!isStoreAddForm, 'row':isStoreAddForm }" formGroupName="storeAddress">
      <div  [ngClass]="{'col-sm-7':!isStoreAddForm, 'col-lg-6 col-md-12 col-sm-6':isStoreAddForm }">
        <div [ngClass]="{'input-field':!isStoreAddForm, 'login__input':isStoreAddForm }">
          @if (!isStoreAddForm || isStoreAddPopup) {
            <label>{{translations.GLOBAL.KEYS.ZIP_CODE | translate}}</label>
          }
          <input type="text" id="storeZcodeInput" [placeholder]="getTranslation(translations.GLOBAL.KEYS.ZIP_CODE)" formControlName="postalCode" />
          @if (storeAddressForm.postalCode.invalid &&
            (isSubmitted)) {
            <div
              class="custom_error">
              <!-- {{getCustomErrorMessage(storeAddressForm.postalCode, getTranslation(translations.GLOBAL.KEYS.ZIP_CODE), { cannotStartWithWhiteSpace: true, minLength:4, maxLength:12 })}} -->
              {{getCustomErrorMessage(storeAddressForm.postalCode, getTranslation(translations.GLOBAL.KEYS.ZIP_CODE) )}}
            </div>
          }
        </div>
      </div>
      <div [ngClass]="{'col-sm-7':!isStoreAddForm, 'col-lg-6 col-md-12 col-sm-6':isStoreAddForm }">
        <div [ngClass]="{'input-field':!isStoreAddForm, 'login__input':isStoreAddForm }">
          @if (!isStoreAddForm || isStoreAddPopup) {
            <label>{{translations.GLOBAL.KEYS.COUNTRY | translate}}</label>
          }
          <input type="text" id="storeCountryInput" placeholder="Country" formControlName="country"/>
          @if (storeAddressForm.country.invalid &&
            (isSubmitted)) {
            <div
              class="custom_error">
              @if (storeAddressForm.country.errors.required) {
                <div>
                  {{getCustomErrorMessage(storeAddressForm.country, getTranslation(translations.GLOBAL.KEYS.COUNTRY))}}
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>

    <div [ngClass]="{'input__row':!isStoreAddForm, 'row':isStoreAddForm }">
      <div [ngClass]="{'col-sm-7':!isStoreAddForm, 'col-lg-12 col-md-12 col-sm-12':isStoreAddForm }">
        <div [ngClass]="{'input-field':!isStoreAddForm, 'login__input':isStoreAddForm }">
          @if (!isStoreAddForm || isStoreAddPopup) {
            <label>{{translations.STORE.SELECT_BUSINESS_TYPE | translate}}</label>
          }
          <ng-select id="storeTypeNameSelect" [hideSelected]='true' [items]="storeAttributes.pageItems" bindLabel="storeTypeName"
            bindValue="_id" [multiple]="true"
            [clearable]="(storeForm.controls.storeTypeIds.value || []).length > 0"
            placeholder="Select Business Type" formControlName="storeTypeIds">
          </ng-select>
          @if (storeForm.controls.storeTypeIds.invalid &&
            (isSubmitted)) {
            <div
              class="custom_error">
              @if (storeForm.controls.storeTypeIds.errors?.required) {
                <div>
                {{getCustomErrorMessage(storeForm.controls.storeTypeIds, getTranslation(translations.STORE.SELECT_BUSINESS_TYPE))}}</div>
              }
            </div>
          }
        </div>
      </div>
    </div>

    <div class="input__row" [formGroup]="storeForm">
      <div [ngClass]="(isLoggedIn === 'true') ? 'col-sm-7 business-hours-box-storeedit' : 'col-sm-12  business-hours-box-signup' ">
        <div class="input-field wbx-business-hours-container">
          <label>{{ translations.GLOBAL.KEYS.BUSINESS_HOURS_LABEL | translate }}</label>
          <div class="business-hours-container">
            <div class="business-hours-labels">
              <div class="business-hours-row">
                <div class="business-hours-row-days hds-labels">{{ translations.GLOBAL.KEYS.AVAILABLE_ON | translate }}</div>
                <div class="business-hours-row-hours">
                  <div class="business-hours-from hds-labels">{{ translations.GLOBAL.KEYS.FROM | translate }}</div>
                  <div class="business-hours-to hds-labels">{{ translations.GLOBAL.KEYS.TO | translate }}</div>
                </div>
              </div>
            </div>
            <div class="business-hours-row-container" formArrayName="businessHours">
              @for (hoursGroup of businessHoursFormArray.controls; track hoursGroup; let i = $index) {
                <div class="business-hours-row" [formGroupName]="i">
                  <div class="business-hours-row-days">
                    <div class="business-days-col-row">
                      @for (label of businessDayLabels; track label; let j = $index) {
                        <div class="business-days-col">
                          <input name="cssCheckbox"
                            [id]="'businessDay' + i + j"
                            type="checkbox"
                            class="css-checkbox"
                            [checked]="isDaySelected(i, j)"
                            [disabled]="isDayDisabled(i, j)"
                            (change)="toggleDay(i, j)">
                          <label [for]="'businessDay' + i + j">{{label}}</label>
                        </div>
                      }
                      @if (isSubmitted
                        && hoursGroup?.get('days')?.value?.length > 0
                        && !hoursGroup?.get('open24Hrs')?.value
                        && (!hoursGroup?.get('timeFrom')?.value || !hoursGroup?.get('timeTo')?.value)) {
                        <div
                          class="custom_error">
                          Please complete the time range
                        </div>
                      }
                      @if (hasOverlappingTime(i)) {
                        <div class="custom_error">Overlapping time not allowed</div>
                      }
                    </div>
                  </div>
                  <div class="business-hours-row-hours" style="padding-bottom:20px;">
                    <div class="business-hours-from">
                      <ng-select [items]="businessHoursTimeSlots"
                        bindLabel="name"
                        bindValue="id"
                        placeholder="Select : -"
                        formControlName="timeFrom"
                        (change)="onBusinessHoursTimeChange()">
                      </ng-select>
                    </div>
                    <div class="business-hours-to">
                      <ng-select [items]="businessHoursTimeSlots"
                        bindLabel="name"
                        bindValue="id"
                        placeholder="Select : -"
                        formControlName="timeTo"
                        (change)="onBusinessHoursTimeChange()">
                      </ng-select>
                    </div>
                     <div class="business-hours-row-check">
                              <div class="fancy-wbx-checkbox--field">
                                <div class="wbx-simple-checkbox-input-set">
                                  <div class="wbx-simple-checkbox-input-set-item">
                                    <input
                                      type="checkbox"
                                      class="wbx-toggle-radio"
                                      [id]="'open24HrsInput' + i"
                                      [name]="'open24HrsInput' + i"
                                      formControlName="open24Hrs"
                                      [disabled]="!isAnyDaySelected(i)"
                                      (change)="onOpen24HrsChange(i)" />
                                    <label [for]="'open24HrsInput' + i">{{ translations.GLOBAL.KEYS.OPEN_24_HRS | translate }}</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                    @if (businessHoursFormArray?.length > 1) {
                      <button class="delete-business-hours-button"
                      (click)="removeBusinessHoursRow(i)"></button>
                    }
                  </div>
                </div>
              }
            </div>
            <div class="business-hours-description-text">
              {{ translations.GLOBAL.KEYS.ENTER_BUSINESS_HOURS_FOR_THE_LOCATION_ABOVE_YOU_CAN_ADD_MORE_STORE_LOCATIONS_FROM_YOUR_PROFILE_TEXT | translate }}
            </div>
            <button type="button" class="add-business-hours-button" (click)="addBusinessHoursRow()">+ {{ translations.GLOBAL.KEYS.ADD_ADDITIONAL_HOURS_BUTTON | translate }}</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Billing address sections hidden for consistency with merchant signup -->
    <!-- <div [ngClass]="{'input__row':!isStoreAddForm, 'row':isStoreAddForm }">
      <div [ngClass]="{'col-sm-7':!isStoreAddForm, 'col-lg-12 col-md-12 col-sm-12':isStoreAddForm }">
        <div [ngClass]="{'input-field':!isStoreAddForm, 'login__input':isStoreAddForm }">
          <div class="form-check billing-address-check">
            <div class="remember-me" id="loginRmInput">
              <input class="css-checkbox" id="billingAddressSame" formControlName="isBillingAddressSame"
                (change)="onBillingAddressSameChange($event)" name="checkboxG1" type="checkbox">
              <label class="css-label" for="billingAddressSame"> The billing address is the same as Address 1</label>
            </div>
          </div>
          @if (!isStoreAddForm || isStoreAddPopup) {
            <label>{{translations.STORE.ADD_YOUR_BILLING_ADDRESS | translate}}</label>
          }
          <input id="storeBillingAdsInput" type="googleInputLocation" [placeholder]="getTranslation(translations.STORE.ADD_YOUR_BILLING_ADDRESS)"
            [addressFormControl]="billingAddress" formControlName="billingAddress" autocorrect="off"[shouldIgnoreSettingFormGroupValue]="true"
            autocapitalize="off" spellcheck="off" (locFormGroupDataChanged)='patchDataForLocFormGroup($event)'
            [disabled]="storeForm.get('isBillingAddressSame').value" />
          @if (storeForm.controls.billingAddress.invalid &&
            (isSubmitted)) {
            <div
              class="custom_error">
              {{getCustomErrorMessage(storeForm.controls.billingAddress, getTranslation(translations.GLOBAL.KEYS.BILLING_ADDRESS))}}
            </div>
          }
          @if (isSubmitted && billingAddress.invalid) {
            <div class="custom_error">
              @if (billingAddress.errors.isValidAddressFromList && (!billingAddress.errors || !billingAddress.errors.required)) {
                <div>
                  {{
                  translations.GLOBAL.VALIDATION_MESSAGES.CHOOSE_ADDRESS_FROM_DROPDOWN |
                  translate : { 'name': translations.GLOBAL.KEYS.BILLING_ADDRESS | translate }
                  }}
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>

    Second Billing Address Section - Copies from Address 2
    <div [ngClass]="{'input__row':!isStoreAddForm, 'row':isStoreAddForm }">
      <div [ngClass]="{'col-sm-7':!isStoreAddForm, 'col-lg-12 col-md-12 col-sm-12':isStoreAddForm }">
        <div [ngClass]="{'input-field':!isStoreAddForm, 'login__input':isStoreAddForm }">
          <div class="form-check billing-address-check">
            <div class="remember-me" id="loginRmInput2">
              <input class="css-checkbox" id="billingAddressFromAddress2" formControlName="isBillingAddressFromAddress2"
                (change)="onBillingAddressFromAddress2Change($event)" name="checkboxG2" type="checkbox">
              <label class="css-label" for="billingAddressFromAddress2"> The billing address is the same as Address 2</label>
            </div>
          </div>
          @if (!isStoreAddForm || isStoreAddPopup) {
            <label>{{translations.STORE.ADD_YOUR_BILLING_ADDRESS | translate}}</label>
          }
          <input id="storeBillingAdsInput2" type="googleInputLocation" [placeholder]="getTranslation(translations.STORE.ADD_YOUR_BILLING_ADDRESS)"
            [addressFormControl]="billingAddress2" formControlName="billingAddress2" autocorrect="off"[shouldIgnoreSettingFormGroupValue]="true"
            autocapitalize="off" spellcheck="off" (locFormGroupDataChanged)='patchDataForLocFormGroup2($event)'
            [disabled]="storeForm.get('isBillingAddressFromAddress2').value" />
          @if (storeForm.controls.billingAddress2.invalid &&
            (isSubmitted)) {
            <div
              class="custom_error">
              {{getCustomErrorMessage(storeForm.controls.billingAddress2, getTranslation(translations.GLOBAL.KEYS.BILLING_ADDRESS))}}
            </div>
          }
          @if (isSubmitted && billingAddress2.invalid) {
            <div class="custom_error">
              @if (billingAddress2.errors.isValidAddressFromList && (!billingAddress2.errors || !billingAddress2.errors.required)) {
                <div>
                  {{
                  translations.GLOBAL.VALIDATION_MESSAGES.CHOOSE_ADDRESS_FROM_DROPDOWN |
                  translate : { 'name': translations.GLOBAL.KEYS.BILLING_ADDRESS | translate }
                  }}
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div> -->

    <div [ngClass]="{'input__row':!isStoreAddForm, 'row':isStoreAddForm }">
      <div [ngClass]="{'col-sm-7':!isStoreAddForm, 'col-lg-12 col-md-12 col-sm-12':isStoreAddForm }">
        <div [ngClass]="{'input-field':!isStoreAddForm, 'login__input':isStoreAddForm }">
          <label class="store-redeem-code-label">
            @if (!isStoreAddForm || isStoreAddPopup) {
              {{translations.GLOBAL.KEYS.STORE_REDEEM_CODE | translate}}
            }
            <i class="wbx-tooltip-icon" [tooltip]="businessRedemptionCodeInfoTooltip" containerClass="wbx-signup-tooltip" placement="top"></i>
          </label>
          <input type="text"  id="storeRedeemInput" formControlName="storeRedeemcode" (keydown.space)="$event.preventDefault();"
            placeholder="{{translations.GLOBAL.KEYS.STORE_REDEEM_CODE | translate}}">
          @if (storeForm.controls.storeRedeemcode.invalid &&
            (isSubmitted)) {
            <div
              class="custom_error">
              <!-- {{getCustomErrorMessage(storeForm.controls.storeRedeemcode, getTranslation(translations.GLOBAL.KEYS.STORE_REDEEM_CODE), { cannotStartWithWhiteSpace: true, minLength:4, maxLength:6 })}} -->
              {{getCustomErrorMessage(storeForm.controls.storeRedeemcode, getTranslation(translations.GLOBAL.KEYS.STORE_REDEEM_CODE) )}}
              <!-- <div *ngIf="storeForm.controls.storeRedeemcode.errors.isUnique">
              {{translations.STORE.REDEEM_CODE_SHOULD_BE_UNIQUE | translate}}
            </div> -->
          </div>
        }
      </div>
    </div>
  </div>

  <div [ngClass]="{'upload-img-admin':!isStoreAddForm, 'upload-img-merchant':isStoreAddForm }" class="signup__upload__img clearfix">
    @for (items of getStoreImages(); track items; let index = $index) {
      <div class="signup_upload__img__box signup_uploaded_imgs"
        >
        <div class="box_upload_img"> <img width="100%"
          [src]="(imageCdn + 'w_300,h_300/' + ((imageBaseUrl + '/'+items) | encodeUri))"
        alt="loading..." /></div>
        <div class="delete_img_upload">
          <a href=" javascript:void(0)" id="storeImgDeleteLink" (click)="removeStoreImg(items,index)"><img
          src="/assets/images/svg_icons/gray-cross.svg" alt=""></a>
        </div>
      </div>
    }
    <div class="signup_upload_img_input signup_upload__img__box">
      <div class="signup_upload__input_opcty">
        <input type="file" id="storeImgUploadInput" ng2FileSelect [uploader]="uploader"
          (change)="uploadImage($event)" accept="image/*">
        </div>
        <div class="signup_upload_img_text">
          <img width="100%" src="/assets/images/svg_icons/upload-store-photo.svg" alt="">
        </div>
      </div>


      @if (error || isSubmitted || getStoreDataToCheckError().invalid) {
        <div
          class="custom_error">
        @if (error) {
          <span>{{error}}</span>
        }
        @if (getStoreDataToCheckError().errors?.required && isSubmitted) {
          <span>{{translations.STORE.STORE_IMAGES_IS_REQUIRED | translate}}</span>
        }
      </div>
    }
  </div>
  <div class="input__button__box input__button__box__row">

    @if (!isStoreAddForm) {
      <button id="storeCancelOneBtn" type="button" id="cancel" (click)="closeForm()" class="gray-btn_outline" id="createcancel">{{translations.GLOBAL.KEYS.CANCEL | translate}}</button>
    }

    @if (isStoreAddPopup) {
      <button id="storeCancelTwoBtn" type="button" id="cancel" (click)="closeForm()" class="gray-btn_outline" id="createcancel">{{translations.GLOBAL.KEYS.CANCEL | translate}}</button>
    }

    <div [ngClass]="{'input__button__box':!isStoreAddForm, 'sign__up__btn clearfix':isStoreAddForm }">
      <!-- <div class="pre__btn" *ngIf="isSignUpForm">
      <button id="storeSkipBtn" (click)="finalStep('step3',true)" class="signup__step_btn">{{translations.STORE.SKIP | translate}}</button>
    </div> -->
    @if (enabledCancelButton) {
      <div class="pre__btn">
        <a  id="storeCancelLink" routerLink="/merchant-dashboard" href="/merchant-dashboard"  [ngClass]="{'orange-btn_outline':!isStoreAddForm, 'signup__step_btn':'isStoreAddForm' }">{{translations.GLOBAL.KEYS.CANCEL | translate}}</a>
      </div>
    }
    <div [ngClass]="{'':!isStoreAddForm, 'next__btn merchant-add-store-submit':isStoreAddForm }">
      <button id="storeSunmitBtn" [ngClass]="{'orange-btn_outline':!isStoreAddForm, 'signup__step_btn':isStoreAddForm }" [disabled]="storeForm.pristine">{{(isStoreAddForm? translations.GLOBAL.KEYS.SUBMIT : translations.GLOBAL.KEYS.UPDATE) | translate}}</button>
    </div>
  </div>
</div>
</div>
</form>
